export const freeContent = {
  part1: {
    location: ["loc_workplace"], // 사무실 및 업무공간만 무료
    people: ["construction"], // 건설 및 정비만 무료
    vocabulary: ["workplace"], // 단어 학습 카테고리 1만 무료
  },
  part2: {
    questions: ["auxiliary"], // 조동사 의문문만 무료
  },
  part3: {
    conversations: [], // 모든 카테고리 유료
  },
  part4: {
    talks: [], // 모든 카테고리 유료
  },
  part5: {
    categories: ["parts-of-speech"], // 문장훈련 카테고리만 무료 (빈칸훈련 제외)
    subcategories: {
      "parts-of-speech": ["present-tense"], // 문장훈련 중 현재시제만 무료
    },
  },
  part6: {
    categories: [], // 모든 카테고리 유료
  },
  // ... 다른 파트들
};
